import {generateAsyncActionCreators} from '../core/reduxUtils';

const addToCartActionCreators = generateAsyncActionCreators(
  'ADD_TO_CART',
  (item) => ({
    item,
  })
);

const getCartItemCountActionCreators = generateAsyncActionCreators(
  'GET_CART_ITEM_COUNT',
  (params) => ({
    params,
  })
);

const actionCreators = {
  addToCart: {
    ...addToCartActionCreators,
  },

  getCartItemCount: {
    ...getCartItemCountActionCreators,
  },

  setCartCandidateProduct(cartCandidateProduct){
    return {
      type: 'SET_CART_CANDIDATE_PRODUCT',
      payload: {
        cartCandidateProduct,
      },
    };
  },

  updateActiveVariantSelection(variantPropertySelection){
    return {
      type: 'UPDATE_ACTIVE_VARIANT_SELECTION',
      payload: {
        variantPropertySelection,
      },
    };
  },

  resetAddToCartModalState(){
    return {
      type: 'RESET_ADD_TO_CART_MODAL_STATE',
      payload: {},
    };
  },
  
  updateAddToCartState(payload){
    return {
      type: 'ADD_TO_CART_STATE',
      payload,
    };
  },
};

export {
  actionCreators,
  addToCartActionCreators,
  getCartItemCountActionCreators,
};
